<template>
  <van-nav-bar left-arrow @click-left="$router.back()">
    <template #title>
      <div class="author" v-show="showAuthor">
        <van-image
          round
          width="0.64rem"
          height="0.64rem"
          fit="cover"
          :src="article.aut_photo"
        />
        <p class="name">{{ article.aut_name }}</p>
        <p
          class="follow"
          :class="{ active: article.is_followed }"
          @click="handlerFollow(article)"
        >
          {{ article.is_followed ? "已关注" : "关注" }}
        </p>
      </div>
    </template>
    <template #right>
      <van-icon @click="$emit('onShowShare')" name="ellipsis" />
    </template>
  </van-nav-bar>
</template>
<script>
import { followMixin } from './mixins'
export default {
  name: 'Article',
  mixins: [followMixin],
  props: {
    article: {
      type: Object,
      default: () => ({})
    },
    showAuthor: {
      type: Boolean,
      default: false
    }
  }
}
</script>
<style scoped lang="less">
.author {
  display: flex;
  align-items: center;
  p {
    margin-left: 10px;
    line-height: 10px;
    font-size: 15px;
    &.follow {
      color: @ttColor;
      padding-left: 10px;
      border-left: 1px solid #bfc2cb;
      font-size: 14px;
      &.active {
        color: #ccc;
      }
    }
  }
}
::v-deep .van-image__loading-icon {
  color: #ddd;
}
::v-deep .van-nav-bar__title {
  margin: 0;
  padding: 0 52px;
  max-width: none;
}
::v-deep .van-icon-ellipsis {
  font-size: 20px;
  color: #333;
}
</style>
